import { Divider } from '@mui/material';
import clsx from 'clsx';
import {
    format, getDay, isToday, isYesterday, startOfWeek
} from 'date-fns';
import { Ref } from 'react';

import styles from './DayDivider.module.scss';
import { SlidingTransitionGroup } from './SlidingTransitionGroup';


interface DayDividerProps {
    date: Date;
    showStartOfWeek: boolean;
    headerRef?: Ref<HTMLDivElement>;
    currentNode?: HTMLElement;
    scrollDirection?: 'up' | 'down';
    showScrollbarPlug?: boolean;
}

export default function DayDivider({
    date, showStartOfWeek, headerRef, currentNode, scrollDirection, showScrollbarPlug
}: DayDividerProps) {
    const dayDisplay = isToday(date)
        ? 'Today'
        : isYesterday(date)
            ? 'Yesterday'
            : dayTranslationMap[getDay(date)];

    const dateStr = date.toISOString();
    const formattedDate = format(date, 'MM/dd/yyyy');
    const weekOfDate = format(startOfWeek(date), 'LLLL do');

    const isCurrentNode = dateStr === currentNode?.dataset.dayHeaderDate;
    const transitionDirection = scrollDirection === 'up' ? 'down' : 'up';

    return (
        <>
            <Divider className={styles.dayDivider} />

            <div
                className={clsx(styles.dateInfo, {
                    [styles.hidden]: isCurrentNode
                })}
                ref={headerRef}
                data-day-header-date={dateStr}
            >
                <SlidingTransitionGroup
                    textContent={dayDisplay}
                    direction={transitionDirection}
                />

                <div className={styles.weekOfContainer}>
                    {showStartOfWeek && (
                        <SlidingTransitionGroup
                            textContent={`Week of ${weekOfDate}`}
                            direction={transitionDirection}
                        />
                    )}
                </div>

                <div className={styles.dateContainer}>
                    <SlidingTransitionGroup
                        textContent={formattedDate}
                        direction={transitionDirection}
                    />
                </div>

                {showScrollbarPlug && (
                    <div className={styles.scrollbarPlug} />
                )}
            </div>
        </>
    );
}

const dayTranslationMap = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
];
